import script from "./topHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./topHeader.vue?vue&type=script&setup=true&lang=js"

import "./topHeader.vue?vue&type=style&index=0&id=7a71aa45&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a71aa45"]])

export default __exports__